export const loginUrl = process.env.REACT_APP_API_BASE + '/oauth/token';
export const currentUserUrl = process.env.REACT_APP_API_BASE + '/users/current';

export default {
  loginUrl,
  currentUserUrl
};
